import { type RouteRecordRaw } from "vue-router";

export const Routes = Object.freeze({
  home: "/",
  products: {
    index: "/products",
    d: "/products/d",
    t: "/products/t",
    mosfet: "/products/f",
    ic: "/products/ic",
  },
  application: "/application",
  aboutUs: {
    index: "/aboutUs",
    brief: "/aboutUs/brief",
    culture: "/aboutUs/culture"
  },
  news: {
    index: "/news",
    company: "/news/company",
    industry: "/news/industry",
    electricKnowledge: "/news/electricKnowledge",
  },
  contact: {
    index: "/contact",
    recruit: "/contact/recruit",
    message: "/contact/message",
  },
  custom: '/custom'
} as const);

const Layout = () => import("@/apps/normal/layout/Layout.vue");

export const Records: RouteRecordRaw[] = [
  {
    path: Routes.home,
    component: Layout,
    children: [
      {
        path: Routes.home,
        component: () => import("@/apps/normal/pages/Home/Index.vue"),
      }
    ]
  },
  {
    path: Routes.products.index,
    component: Layout,
    children: [
      {
        path: Routes.products.index,
        component: () => import("@/apps/normal/pages/Products/Index.vue"),
        children: [
          {
            path: Routes.products.mosfet,
            component: () => import("@/apps/normal/pages/Products/views/MosFET.vue"),
          },
          {
            path: Routes.products.d,
            component: () => import("@/apps/normal/pages/Products/views/Diode.vue"),
          },
          {
            path: Routes.products.t,
            component: () => import("@/apps/normal/pages/Products/views/Triode.vue"),
          },
          {
            path: Routes.products.ic,
            component: () => import("@/apps/normal/pages/Products/views/IC.vue"),
          },
        ]
      },
    ]
  },
  {
    path: Routes.application,
    component: Layout,
    children: [
      {
        path: Routes.application,
        component: () => import("@/apps/normal/pages/Application/Index.vue"),
      }
    ]
  },
  {
    path: Routes.news.index,
    component: Layout,
    children: [
      {
        path: Routes.news.index,
        component: () => import("@/apps/normal/pages/News/Index.vue"),
        children: [
          {
            path: Routes.news.index,
            component: () => import("@/apps/normal/pages/News/Default.vue"),
          }
        ]
      },
    ]
  },
  {
    path: Routes.custom,
    component: Layout,
    children: [
      {
        path: Routes.custom,
        component: () => import("@/apps/normal/pages/Custom/Index.vue"),
        children: [
          {
            path: Routes.custom,
            component: () => import("@/apps/normal/pages/Custom/Default.vue"),
          }
        ]
      },
    ]
  },
];
